/**
 * @generated SignedSource<<7f06a6ac56caa9024cc250ffb15e73ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type MembersProfileFieldFilterDropdownQuery$variables = {
  id: string;
  isPrivate?: boolean | null;
  webFormQuestionTypes?: ReadonlyArray<WebFormQuestionType> | null;
};
export type MembersProfileFieldFilterDropdownQuery$data = {
  readonly organization: {
    readonly id?: string;
    readonly profileFields?: {
      readonly totalCount: number;
    };
  } | null;
};
export type MembersProfileFieldFilterDropdownQuery = {
  response: MembersProfileFieldFilterDropdownQuery$data;
  variables: MembersProfileFieldFilterDropdownQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPrivate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "webFormQuestionTypes"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "defaultTypesToExclude",
      "value": [
        "email_address",
        "public_groups"
      ]
    },
    {
      "kind": "Variable",
      "name": "isPrivate",
      "variableName": "isPrivate"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": "visible"
    },
    {
      "kind": "Variable",
      "name": "webFormQuestionTypes",
      "variableName": "webFormQuestionTypes"
    }
  ],
  "concreteType": "ProfileFieldNodeConnection",
  "kind": "LinkedField",
  "name": "profileFields",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MembersProfileFieldFilterDropdownQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MembersProfileFieldFilterDropdownQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f258d3f3310def7038d80bc938ddf0b2",
    "id": null,
    "metadata": {},
    "name": "MembersProfileFieldFilterDropdownQuery",
    "operationKind": "query",
    "text": "query MembersProfileFieldFilterDropdownQuery(\n  $id: ID!\n  $isPrivate: Boolean\n  $webFormQuestionTypes: [WebFormQuestionType!]\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      id\n      profileFields(status: visible, defaultTypesToExclude: [email_address, public_groups], isPrivate: $isPrivate, webFormQuestionTypes: $webFormQuestionTypes) {\n        totalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c424823c839d8c2a1296bbbb62aa4db";

export default node;
